import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/Topbar";
import { ShieldCheck, Lock, LockOpen, ToggleRight, ToggleLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { CUSTOMER_BILLING_ENABLED } from "@/lib/features";

const PAYMENT_ACTION_CODES = new Set(["send_payment_link", "send_receipt"]);

export default function Actions() {
  const [rows, setRows] = useState([]);
  const load = async () => {
    const { data } = await api.get("/actions");
    const filtered = CUSTOMER_BILLING_ENABLED
      ? data
      : data.filter((r) => !PAYMENT_ACTION_CODES.has(r.code));
    setRows(filtered);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (r, field) => {
    const payload = { code: r.code, name: r.name, description: r.description, requires_confirmation: r.requires_confirmation, enabled: r.enabled, [field]: !r[field] };
    await api.put(`/actions/${r.id}`, payload);
    toast.success("Atualizado");
    load();
  };

  return (
    <>
      <Topbar title="O que o AgentUS pode fazer" subtitle="Lista de ações que o agente está autorizado a executar nas conversas." />
      <div className="p-6 md:p-8 space-y-4">
        <div className="bg-blue-50 border border-blue-200 text-blue-900 rounded-md p-4 text-sm flex items-start gap-3">
          <ShieldCheck size={20} weight="fill" className="text-blue-700 shrink-0 mt-0.5" />
          <div>
            Toda ação sensível (como <strong>criar agendamento</strong>{CUSTOMER_BILLING_ENABLED ? <> ou <strong>enviar link de pagamento</strong></> : null}) exige confirmação antes do AgentUS executar.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rows.map((r) => (
            <div key={r.id} className="bg-white border border-slate-200 rounded-md p-5" data-testid={`action-card-${r.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-heading font-semibold text-slate-900 tracking-tight">{r.name}</div>
                  <div className="font-mono text-xs text-slate-500 mt-1">{r.code}</div>
                  {r.description && <p className="text-sm text-slate-600 mt-2">{r.description}</p>}
                </div>
                <button onClick={() => toggle(r, "enabled")} className="p-1.5" title="Ativar/desativar">
                  {r.enabled ? <ToggleRight size={26} weight="fill" className="text-blue-700" /> : <ToggleLeft size={26} className="text-slate-400" />}
                </button>
              </div>
              <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-sm">
                <div className="flex items-center gap-2 text-slate-700">
                  {r.requires_confirmation ? <Lock size={14} className="text-amber-600" /> : <LockOpen size={14} className="text-emerald-600" />}
                  {r.requires_confirmation ? "Exige confirmação" : "Execução direta"}
                </div>
                <button onClick={() => toggle(r, "requires_confirmation")} className="text-xs text-blue-700 hover:underline">Alternar</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
